"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownInput = exports.DropdownInputEmptyOption = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const dropdown_1 = require("../../dropdown");
exports.DropdownInputEmptyOption = {
    label: '',
    value: null,
};
const DropdownInput = ({ control, name, label, disabled, options, transformer, placeholder, searchableOptions, sortedOptions, rules, testid, }) => {
    const { field, fieldState: { error }, } = (0, react_hook_form_1.useController)({ control, name, rules });
    const getValue = () => {
        if ((0, util_1.isDefined)(transformer)) {
            return transformer.in(field.value);
        }
        return options.find((o) => o.value === field.value);
    };
    const onChange = (v) => {
        if ((0, util_1.isDefined)(transformer)) {
            field.onChange(transformer.out(v));
            return;
        }
        field.onChange(v.value);
    };
    const value = getValue();
    return (react_1.default.createElement(dropdown_1.Dropdown, { style: dropdown_1.Dropdown.STYLES.LIGHT, type: dropdown_1.Dropdown.TYPES.VARIABLE, size: dropdown_1.Dropdown.SIZES.FULL_WIDTH, label: (0, maybe_unwrap_1.unwrapMaybe)(label), options: options, singleSelect: true, value: value, onChange: onChange, disabled: field.disabled || disabled, sortedOptions: sortedOptions, searchable: searchableOptions, disableSort: sortedOptions, placeholder: placeholder, hasError: (0, util_1.isDefined)(error), errorMessage: error?.message, testid: testid }));
};
exports.DropdownInput = DropdownInput;
